/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      images: [],
      show: false,
      imgSrc: '',
      empty: false
    };
  },
  methods: {
    onChange: function onChange() {
      console.log(1);
    },
    imgClick: function imgClick() {
      this.show = true;
    },
    getImgSrc: function getImgSrc() {
      var _this = this;

      this.$api.Home.weekMeal({
        userSerial: this.$utils.Store.getItem('userSerial')
      }).then(function (res) {
        console.log(res);
        var data = res.data,
            code = res.code,
            msg = res.msg;

        if (code == 600) {
          if (data) {
            _this.imgSrc = data;

            _this.images.push(data);
          } else {
            _this.empty = true;
          }
        } else {
          _this.empty = true;

          _this.$utils.Tools.toastShow(msg);
        }
      });
    }
  },
  created: function created() {
    this.getImgSrc();
  },
  mounted: function mounted() {}
};